import { Col, Container, Row } from "react-bootstrap";
import AmazonDeliveryMetricsTableComponent from "../components/amazonDeliveryMetricsTable";
import AmazonDeliveryDateFilterComponent from "../components/filters/amazonDeliveryDateFilterComponent";
import UploadAmazonDeliveryMetricsComponent from "../components/amazonDeliveryMetricsUpload";
import AmazonDeliveryMetricsExportComponent from "../components/amazonDeliveryMetricsXlsxExport";
import { AmazonDeliveryMetricsProvider, useAmazonDeliveryMetricsContext } from "../contexts/amazonDeliveryMetricsContext";
import AmazonDeliveryApplyClearFilterComponent from "../components/filters/amazonDeliveryApplyClearFiltersComponent";
import AmazonDeliveryReasonFilterComponent from "../components/filters/amazonDeliveryReasonFilterComponent";
import { useMemo } from 'react';

const AmazonDeliveryMetrics = () => {

  const {
    currentError,
    handleFileChange,
    uploadFile,
    handleAmazonDeliveryMetricsDetailedExport,
    handleAmazonDeliveryMetricsTableExport
  } = useAmazonDeliveryMetricsContext()

  if (currentError) return <div>{currentError}</div>

  const view = useMemo(() => {
    return <>
      <Container fluid className="mt-4 text-center">
        <Row className="justify-content-md-center mb-5">
          <Col md="auto" className="fs-2 fw-bold">Amazon Delivery Metrics</Col>
        </Row>
        <Row className="justify-content-md-center mb-3">
          <Col md="auto">
          <AmazonDeliveryDateFilterComponent />
          <AmazonDeliveryReasonFilterComponent />
          <AmazonDeliveryApplyClearFilterComponent />
          </Col>
          <Col md="auto">
            <UploadAmazonDeliveryMetricsComponent
              handleFileChange={handleFileChange}
              uploadFile={uploadFile}
            />
          </Col>
        </Row>
        <Row className="justify-content-md-center mb-3">
          <Col md="auto">
            <AmazonDeliveryMetricsExportComponent 
              exportDetailedFile={handleAmazonDeliveryMetricsDetailedExport}
              exportTableFile={handleAmazonDeliveryMetricsTableExport}
            />
          </Col>
        </Row>
        <Row>
          <Col>
            <AmazonDeliveryMetricsTableComponent />
          </Col>
        </Row>
      </Container>
    </>
  }, [
    currentError,
    handleFileChange,
    uploadFile,
    handleAmazonDeliveryMetricsDetailedExport,
    handleAmazonDeliveryMetricsTableExport
  ])

  return view
}

export default function AmazonDeliveryMetricsWrapper() {
  return (
    <AmazonDeliveryMetricsProvider>
      <AmazonDeliveryMetrics />
    </AmazonDeliveryMetricsProvider>
  );
}